/* mirai-article-products.js: blog product cards (DRAFT 2026-10-30, not installed)
 * - GA4 ecommerce events to window.dataLayer: view_item_list, select_item, add_to_cart
 *   (item_list_id/item_list_name = article handle, plus placement as creative_slot and the custom param mirai_placement)
 * - The same payloads go to Shopify customer events via Shopify.analytics.publish('mirai_article_*'),
 *   so a Custom Pixel can forward them (the GA4 tag runs in the sandboxed Google & YouTube app pixel and cannot read window.dataLayer)
 * - AJAX add: /cart/add.js with hidden line-item properties _source_article/_source_placement,
 *   then /cart/update.js with cart attributes source_article/source_placement (last touch)
 * - Re-checks /products/<handle>.js when a card is near the viewport and hides it if it is now unavailable
 * - v2: button label -> 'Added ✓' for 4s on success; Shopify cart errors mapped to short copy ('Only N left' / 'Couldn't add, try again')
 */
(function () {
  'use strict';
  if (window.__miraiArticleProducts) return;
  window.__miraiArticleProducts = true;

  var dl = (window.dataLayer = window.dataLayer || []);
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ctx(card) {
    var mod = card.closest('[data-mac]');
    return {
      module: mod,
      article: mod.getAttribute('data-mac-article'),
      blog: mod.getAttribute('data-mac-blog'),
      placement: mod.getAttribute('data-mac-placement')
    };
  }

  function item(card, c) {
    return {
      item_id: card.getAttribute('data-product-id'),
      item_name: card.getAttribute('data-item-name'),
      item_brand: card.getAttribute('data-item-brand'),
      item_category: card.getAttribute('data-item-category') || undefined,
      item_variant: card.getAttribute('data-variant-id'),
      price: parseFloat(card.getAttribute('data-price')) || undefined,
      currency: card.getAttribute('data-currency') || undefined,
      index: parseInt(card.getAttribute('data-mac-index'), 10) || 0,
      item_list_id: c.article,
      item_list_name: c.article,
      creative_slot: c.placement,
      quantity: 1
    };
  }

  function track(event, card, extra) {
    var c = ctx(card);
    var it = item(card, c);
    var payload = {
      event: event,
      mirai_placement: c.placement,
      mirai_article: c.article,
      mirai_blog: c.blog,
      ecommerce: Object.assign(
        { item_list_id: c.article, item_list_name: c.article, currency: card.getAttribute('data-currency') || undefined, items: [it] },
        event === 'add_to_cart' ? { value: it.price } : {},
        extra || {}
      )
    };
    dl.push({ ecommerce: null }); // GA4 recommended: clear the previous ecommerce object
    dl.push(payload);
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('mirai_article_' + event, { article: c.article, blog: c.blog, placement: c.placement, item: it });
      }
    } catch (e) { /* analytics must never break the page */ }
  }

  function setStatus(card, text, state) {
    var s = card.querySelector('.mac__status');
    card.setAttribute('data-state', state || '');
    if (!s) return;
    if (text) { s.textContent = text; s.hidden = false; } else { s.textContent = ''; s.hidden = true; }
  }

  function refreshCartUI(response, button) {
    return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (result) {
        if (!result.ok) throw new Error('Cart refresh failed');
        return result.json();
      })
      .then(function (cart) {
        cart.sections = response.sections || {};
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: response } }));
        var drawer = document.querySelector('cart-drawer');
        if (window.innerWidth >= 750 && drawer && typeof drawer.show === 'function') drawer.show(button);
      })
      .catch(function () {
        window.location.assign(rootUrl + 'cart');
      });
  }

  // Map Shopify's /cart/add.js error (422 {status, message, description}) to the brief's short copy
  function errorCopy(mod, err) {
    var generic = mod.getAttribute('data-mac-t-error') || "Couldn't add, try again";
    var only = mod.getAttribute('data-mac-t-only') || 'Only [n] left';
    var d = String((err && (err.description || err.message)) || '');
    // e.g. "You can only add 2 of this item to your cart." / "All 2 X are in your cart."
    var m = err && err.status === 422 && !/sold out/i.test(d) && d.match(/(\d+)/);
    if (m && Number(m[1]) > 0) return only.replace('[n]', m[1]);
    return generic;
  }

  function addToCart(btn) {
    var card = btn.closest('[data-mac-card]');
    var c = ctx(card);
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    if (!btn.hasAttribute('data-mac-label')) btn.setAttribute('data-mac-label', btn.textContent);
    clearTimeout(btn.__macReset);
    btn.textContent = btn.getAttribute('data-mac-label');
    setStatus(card, '', 'loading');
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));
    var body = {
      items: [{
        id: Number(btn.getAttribute('data-variant-id')),
        quantity: 1,
        properties: { _source_article: c.article, _source_placement: c.placement }
      }],
      sections: sections,
      sections_url: rootUrl
    };
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) { j = j || {}; if (!j.status) j.status = r.status; throw j; }
          return j;
        });
      })
      .then(function (res) {
        track('add_to_cart', card);
        setStatus(card, c.module.getAttribute('data-mac-t-added'), 'added');
        btn.textContent = c.module.getAttribute('data-mac-t-added-btn') || 'Added ✓';
        btn.__macReset = setTimeout(function () {
          btn.textContent = btn.getAttribute('data-mac-label');
          if (card.getAttribute('data-state') === 'added') setStatus(card, '', '');
        }, 4000);
        // last-touch article attribution on the cart/order (best effort, non-blocking)
        fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { source_article: c.article, source_placement: c.placement } })
        }).catch(function () {});
        return refreshCartUI(res, btn);
      })
      .catch(function (err) {
        if (window.console && console.warn) console.warn('[mirai-article-products] add failed', err);
        setStatus(card, errorCopy(c.module, err), 'error');
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-mac] [data-mac-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var link = e.target.closest && e.target.closest('[data-mac] [data-mac-link]');
    if (link) track('select_item', link.closest('[data-mac-card]'));
  });

  // view_item_list once per module when 50% visible + live availability re-check (stale page cache guard)
  function onVisible(mod) {
    var cards = Array.prototype.slice.call(mod.querySelectorAll('[data-mac-card]'));
    cards.forEach(function (card) {
      var h = card.getAttribute('data-product-handle');
      fetch(rootUrl + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && p.available === false) {
            card.hidden = true;
            card.setAttribute('data-state', 'oos');
            if (!mod.querySelector('[data-mac-card]:not([hidden])')) mod.hidden = true;
          }
        })
        .catch(function () {});
    });
    if (!cards.length) return;
    var c = ctx(cards[0]);
    var items = cards.map(function (card) { return item(card, c); });
    dl.push({ ecommerce: null });
    dl.push({ event: 'view_item_list', mirai_placement: c.placement, mirai_article: c.article, mirai_blog: c.blog,
      ecommerce: { item_list_id: c.article, item_list_name: c.article, items: items } });
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('mirai_article_view_item_list', { article: c.article, blog: c.blog, placement: c.placement, items: items });
      }
    } catch (e) {}
  }

  function init() {
    var mods = document.querySelectorAll('[data-mac]:not([data-mac-ready])');
    if (!mods.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); onVisible(en.target); }
      });
    }, { threshold: 0.5 }) : null;
    Array.prototype.forEach.call(mods, function (m) {
      m.setAttribute('data-mac-ready', '');
      if (io) io.observe(m); else onVisible(m);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

